/*
 * @FilePath     : /fe-estrain-customer/src/store/modules/company/index.js
 * @Author       : LiYang
 * @Date         : 2021-08-26 16:32:00
 * @LastEditTime : 2021-08-26 16:37:18
 * @LastEditors  : Please set LastEditors
 * @Description  :
 */
import { createStore } from '@mpxjs/core'
import state from './state'
import mutations from './mutation'
import actions from './action'
import getters from './getter'

export default createStore({
  state,
  getters,
  mutations,
  actions
})
